import './Projects.css';

const projects = [
  {
    id: 1,
    title: 'RSNA Intracranial Aneurysm Detection',
    description: 'Silver medal solution (top 2.3%) for detecting aneurysms in 3D head CT angiography. Fine-tuned nnInteractive encoder for detection and localization.',
    tech: ['Python', 'PyTorch', '3D Medical Imaging'],
    links: {
      github: 'https://github.com/bogdanmagometa/rsna',
      certificate: 'https://www.kaggle.com/certification/competitions/bohdanmahometa/rsna-intracranial-aneurysm-detection',
      demo: 'https://aneurysm.bohdanmahometa.com/'
    },
    year: '2025'
  },
  {
    id: 2,
    title: 'Bookmap ML Contest',
    description: '2nd place ($2000 prize) in predicting the fate of limit orders in the stock market based on high-frequency trading history.',
    tech: ['Python', 'XGBoost', 'Time Series'],
    links: {
      github: 'https://github.com/bogdanmagometa/bookmap',
      writeup: 'https://docs.google.com/document/d/1EmqStUhLzQI5XjZ7mPGhASffPZs1Onaj9tvaeH-7Nqo/edit?usp=sharing'
    },
    year: '2025'
  },
  {
    id: 3,
    title: 'Driving Exam Notifications Bot',
    description: 'Telegram bot that notifies users about driving exam openings at MIA service centers in Ukraine.',
    tech: ['Python', 'Telegram API', 'AWS'],
    links: {
      github: 'https://github.com/bogdanmagometa/e-zapys',
      bot: 'https://t.me/mia_en_bot'
    },
    year: '2025'
  },
  {
    id: 4,
    title: 'Enhancing Antibody Structure Prediction',
    description: 'Bachelor thesis: Fine-tuned AlphaFold-Multimer for paired antibody structure prediction, achieving 10% relative reduction in backbone RMSD for the CDRH3 loop.',
    tech: ['Python', 'PyTorch', 'AlphaFold'],
    links: {
      github: 'https://github.com/bogdanmagometa/abs',
      thesis: 'https://hdl.handle.net/20.500.14570/5671',
      slides: 'https://docs.google.com/presentation/d/1AwylwGJ-1DBFVVBvDBULoTT9eYzG1UHDmYll-3E6_KA/edit?usp=sharing'
    },
    year: '2024'
  },
  {
    id: 5,
    title: 'CZII CryoET Object Identification',
    description: 'Silver medal solution (top 4.2%) for protein complex identification in 3D cryo-electron tomography volumes using ensemble of 3D U-Nets.',
    tech: ['Python', 'PyTorch', 'CryoET'],
    links: {
      github: 'https://github.com/bogdanmagometa/cryoET',
      certificate: 'https://www.kaggle.com/certification/competitions/bohdanmahometa/czii-cryo-et-object-identification'
    },
    year: '2024'
  },
  {
    id: 6,
    title: 'Image Retrieval for Clothes',
    description: 'Content-based image retrieval system for clothing items using deep learning embeddings.',
    tech: ['Python', 'PyTorch', 'Computer Vision'],
    links: {
      report: 'https://github.com/bogdanmagometa/image-retrieval/blob/main/report.pdf'
    },
    year: '2024'
  },
  {
    id: 7,
    title: 'Implicit Neural Representations of 3D Meshes',
    description: 'Implementation of signed distance functions using neural networks to represent 3D shapes.',
    tech: ['Python', 'PyTorch'],
    links: {
      report: 'https://github.com/bogdanmagometa/sdf/blob/main/report.pdf'
    },
    year: '2024'
  },
  {
    id: 8,
    title: 'Heat Equation Solver',
    description: 'Solving the heat equation by fitting neural networks as function approximators.',
    tech: ['Python', 'PyTorch', 'PINNs'],
    links: {
      github: 'https://github.com/bogdanmagometa/heat-equation-solver'
    },
    year: '2023'
  },
  {
    id: 9,
    title: 'Neural Network from Scratch',
    description: 'Manual implementation of neural networks with tensor differentiation, PyTorch-like API, training loops, layers, and optimizers.',
    tech: ['Python', 'NumPy'],
    links: {
      github: 'https://github.com/bogdanmagometa/NN'
    },
    year: '2022'
  },
  {
    id: 10,
    title: 'Parallel Neural Network Library',
    description: 'C++ framework for customizable MLPs with parallelized matrix operations, achieving 3x speedup.',
    tech: ['C++', 'Parallel Computing'],
    links: {
      github: 'https://github.com/AlicesRestaurant/parallel-NN-library'
    },
    year: '2022'
  },
  {
    id: 11,
    title: 'CUDA Integral Computation',
    description: 'Achieved 1200% speedup using CUDA parallelization for computing integrals.',
    tech: ['C++', 'CUDA'],
    links: {
      github: 'https://github.com/bogdanmagometa/integral_additional'
    },
    year: '2022'
  },
  {
    id: 12,
    title: 'Logic Circuit Simulator',
    description: 'Algorithm for evaluating combinational and sequential logic circuits.',
    tech: ['Python'],
    links: {
      github: 'https://github.com/archy-co/l4logic'
    },
    year: '2020'
  }
];

function Projects() {
  return (
    <main className="projects container">
      <header className="projects-header animate-in delay-1">
        <h1>Projects</h1>
        <p className="projects-subtitle">Research, competitions, and open source</p>
      </header>

      <div className="projects-list">
        {projects.map((project, index) => (
          <article 
            key={project.id} 
            className={`project-card animate-in delay-${Math.min(index + 2, 4)}`}
          >
            <div className="project-meta">
              <span className="project-year">{project.year}</span>
            </div>
            <div className="project-content">
              <h2 className="project-title">{project.title}</h2>
              <p className="project-description">{project.description}</p>
              <ul className="project-tech">
                {project.tech.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
              <div className="project-links">
                {project.links.demo && (
                  <a href={project.links.demo} target="_blank" rel="noopener noreferrer">
                    Demo ↗
                  </a>
                )}
                {project.links.github && (
                  <a href={project.links.github} target="_blank" rel="noopener noreferrer">
                    Code ↗
                  </a>
                )}
                {project.links.report && (
                  <a href={project.links.report} target="_blank" rel="noopener noreferrer">
                    Report ↗
                  </a>
                )}
                {project.links.thesis && (
                  <a href={project.links.thesis} target="_blank" rel="noopener noreferrer">
                    Thesis ↗
                  </a>
                )}
                {project.links.slides && (
                  <a href={project.links.slides} target="_blank" rel="noopener noreferrer">
                    Slides ↗
                  </a>
                )}
                {project.links.writeup && (
                  <a href={project.links.writeup} target="_blank" rel="noopener noreferrer">
                    Write-up ↗
                  </a>
                )}
                {project.links.certificate && (
                  <a href={project.links.certificate} target="_blank" rel="noopener noreferrer">
                    Certificate ↗
                  </a>
                )}
                {project.links.bot && (
                  <a href={project.links.bot} target="_blank" rel="noopener noreferrer">
                    Try it ↗
                  </a>
                )}
              </div>
            </div>
          </article>
        ))}
      </div>
    </main>
  );
}

export default Projects;
